import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import axios from 'axios';
import QRCode from 'qrcode.react';
import paper from '../../../src/assets/images/paper.jpg';
import 'react-datepicker/dist/react-datepicker.css';
import './Validate.css';

function Validate() {
    const iranProvinces = [
        { ID: 1, EnglishName: "Ardabil" },
        { ID: 2, EnglishName: "Isfahan" },
        { ID: 3, EnglishName: "Alborz" },
        { ID: 4, EnglishName: "Ilam" },
        { ID: 5, EnglishName: "East Azerbaijan" },
        { ID: 6, EnglishName: "West Azerbaijan" },
        { ID: 7, EnglishName: "Bushehr" },
        { ID: 8, EnglishName: "Tehran" },
        { ID: 9, EnglishName: "Chaharmahal and Bakhtiari" },
        { ID: 10, EnglishName: "South Khorasan" },
        { ID: 11, EnglishName: "Razavi Khorasan" },
        { ID: 12, EnglishName: "North Khorasan" },
        { ID: 13, EnglishName: "Khuzestan" },
        { ID: 14, EnglishName: "Zanjan" },
        { ID: 15, EnglishName: "Semnan" },
        { ID: 16, EnglishName: "Sistan and Baluchestan" },
        { ID: 17, EnglishName: "Fars" },
        { ID: 18, EnglishName: "Qazvin" },
        { ID: 19, EnglishName: "Qom" },
        { ID: 20, EnglishName: "Kurdistan" },
        { ID: 21, EnglishName: "Kerman" },
        { ID: 22, EnglishName: "Kermanshah" },
        { ID: 23, EnglishName: "Kohgiluyeh and Boyer-Ahmad" },
        { ID: 24, EnglishName: "Golestan" },
        { ID: 25, EnglishName: "Guilan" },
        { ID: 26, EnglishName: "Lorestan" },
        { ID: 27, EnglishName: "Mazandaran" },
        { ID: 28, EnglishName: "Markazi" },
        { ID: 29, EnglishName: "Hormozgan" },
        { ID: 30, EnglishName: "Hamadan" },
        { ID: 31, EnglishName: "Yazd" },
        { ID: 389452, EnglishName: "Mantaghe Jonob Kerman" }
    ];


    const [hasSearchParams, setHasSearchParams] = useState(false);
    const [loading, setLoading] = useState(true);
    const [provinces, setProvinces] = useState(iranProvinces);
    const [result, setResult] = useState({});
    const [attachments, setAttachments] = useState([]);
    const [resultState, setResultState] = useState('none'); // none, loading, notFound, found
    const [date, setDate] = useState(new Date());
    const [place, setPlace] = useState(null);
    const [code, setCode] = useState('');

    useEffect(() => {
        axios
            .post('Place/List', { Type: 2 })
            .then((result) => {
                if (result.data.Success && result.data.Data && result.data.Data.length) {
                    //setProvinces(result.data.Data);
                }

                if (window.location.search) {
                    const params = new URLSearchParams(window.location.search);
                    setCode(params.get('sn'));
                    setPlace(params.get('poi'));
                    setDate(new Date(parseInt(params.get('d'))));
                    setHasSearchParams(true);
                }
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);
    useEffect(() => {
        if (hasSearchParams)
            search();
    }, [hasSearchParams]);

    return (
        <div>
            <h2>Phytosanitary Certificate Search</h2>

            <fieldset disabled={loading} style={{ all: 'unset', display: 'block' }}>
                <div className="row">
                    <div className="form-group">
                        <label>Date</label>
                        <DatePicker
                            selected={date}
                            onChange={value => setDate(value)}
                            className="form-control"
                        />
                    </div>
                    <div className="form-group">
                        <label>Place of Issue</label>
                        <select className="form-control" value={place} onChange={e => setPlace(e.target.value)}>
                            {provinces.map(function (p, i) {
                                return (<option key={i} value={p.ID}>{p.EnglishName}</option>);
                            })}
                        </select>
                    </div>
                    <div className="form-group">
                        <label>Serial No</label>
                        <input type="text" className="form-control" value={code} onChange={e => setCode(e.target.value)} />
                    </div>
                </div>
                <div className="row button-container">
                    <button type="button" onClick={search}>Search</button>
                </div>
            </fieldset>
            <QRCode
                id="qrcode-canvas"
                style={{ display: 'none' }}
                value={`http://ephyto.pms.ppo.ir/phytosanitary?sn=${code}&poi=${place}&d=${date.getTime()}`}
            />
            {resultState !== 'none' && (
                <div className="row result-container">
                    {resultState === 'loading' && <code>Loading...</code>}
                    {resultState === 'notFound' && <code>No phytosanitary certificate was found with these information.</code>}
                    {resultState === 'found' && (
                        <code>
                            Certificate exists. <span className="link" onClick={print}>(view document)</span>
                            {attachments.map((attachment, index) => {
                                return (
                                    <p key={index}>
                                        <a href={attachment.filePath} target="_blank">attachment #{index + 1}</a>
                                    </p>
                                );
                            })}
                        </code>
                    )}
                </div>
            )}
            {resultState === 'found' && (
                <div id="print" style={{ display: 'none' }}>
                    <div id="print-container" style={{ backgroundImage: `url(${paper})`, backgroundSize: 'cover' }}>
                        <img id="qrcode-image" style={{ position: 'absolute', width: '2cm', height: '2cm', top: '2cm', left: '17.85cm' }} />
                        <div className="part" id="p0">
                            {result.SerialNo}
                        </div>
                        <div className="part" id="p1">
                            {result.ExporterName} <br />
                            {result.ExporterPostalCode} <br />
                            {result.ExporterAddress} <br />
                            {result.ExporterAddress2 && <span>{result.ExporterAddress2} <br /></span>}
                            {result.ExporterTel} <br />
							***************************
						</div>
                        <div className="part" id="p2">
                            {result.ConsigneeName} <br />
                            {result.ConsigneeAddress} <br />
							****************************************
						</div>
                        <div className="part" id="p3">{result.CountryEnglishName}</div>
                        <div className="part" id="p4">{result.SourceCountryEnglishName}</div>
                        <div className="part" id="p5">{result.TConveyance11}</div>
                        <div className="part" id="p6">{result.EntryPoint}</div>
                        <div>
                            <div class="part" id="p7-0">
                                {result.Products.map((product, index) => {
                                    return (
                                        <span key={index}>
                                            {(product.ID && (product.ProductEnglishName != "") ) && <span>{index + 1}</span>}
                                            {!product.ID && <span>*</span>}
                                            <br />
                                            {(product.T3 || product.T4) && <br />}
                                        </span>
                                    );
                                })}
                            </div>
                            <div class="part" id="p7-1">
                                {result.Products.map((product, index) => {
                                    return (
                                        <span key={index}>
                                            {product.ProductEnglishName && <span>{product.ProductEnglishFullName2}</span>}
                                            {!product.ProductEnglishName && <span>***************</span>}
                                            <br />
                                            {(product.T3 || product.T4) && <br />}
                                        </span>
                                    );
                                })}
                            </div>
                            <div class="part" id="p7-2">
                                {result.Products.map((product, index) => {
                                    return (
                                        <span key={index}>
                                            {product.ProductScientificName && <span>{product.ProductScientificName}</span>}
                                            {!product.ProductScientificName && <span>***************</span>}
                                            <br />
                                            {(product.T3 || product.T4) && <br />}
                                        </span>
                                    );
                                })}
                            </div>
                            <div class="part" id="p7-3">
                                {result.Products.map((product, index) => {
                                    return (
                                        <span key={index}>
                                            {((product.NoOfPackages || product.TypeOfPackagesName) && (product.ProductEnglishName != "")) && <span>{`${product.NoOfPackages} ${product.TypeOfPackagesName}`}</span>}
                                            {((!product.NoOfPackages && !product.TypeOfPackagesName) || (product.ProductEnglishName == "") ) && <span>***************</span>}
                                            <br />
                                            {(product.T3 || product.T4) && <br />}
                                        </span>
                                    );
                                })}
                            </div>
                            <div class="part" id="p7-4">
                                {result.Products.map((product, index) => {
                                    return (
                                        <span key={index}>
                                            {product.T1 && <span>{product.T1}</span>}
                                            {!product.T1 && <span>************</span>}
                                            <br />
                                            {product.T3 && <span>{product.T3}</span>}
                                            {(!product.T3 && product.T4) && <span>************</span>}
                                            {(product.T3 || product.T4) && <br />}
                                        </span>
                                    );
                                })}
                            </div>
                            <div class="part" id="p7-5">
                                {result.Products.map((product, index) => {
                                    return (
                                        <span key={index}>
                                            {product.T2 && <span>{product.T2}</span>}
                                            {!product.T2 && <span>************</span>}
                                            <br />
                                            {product.T4 && <span>{product.T4}</span>}
                                            {(product.T3 && !product.T4) && <span>************</span>}
                                            {(product.T3 || product.T4) && <br />}
                                        </span>
                                    );
                                })}
                            </div>
                        </div>
                        <div class="part" id="p9">{result.AdditionalDeclaration} {generateStars(result.AdditionalDeclaration, 80)}</div>
                        <div class="part" id="p10">
                            {result.Disinfection2Treatment && <span>{result.Disinfection2Treatment}</span>}
                            {!result.Disinfection2Treatment && <span>*****</span>}
                        </div>
                        <div class="part" id="p11">
                            {result.Disinfection2ChemicalEnglishName && <span>{result.Disinfection2ChemicalEnglishName}</span>}
                            {!result.Disinfection2ChemicalEnglishName && <span>*****</span>}
                        </div>
                        <div class="part" id="p12">
                            {result.Disinfection2Temperature && <span>{result.Disinfection2Temperature}</span>}
                            {!result.Disinfection2Temperature && <span>*****</span>}
                            <span></span>
                            {result.Disinfection2DurationTime && <span>{result.Disinfection2DurationTime}</span>}
                            {!result.Disinfection2DurationTime && <span>*****</span>}
                        </div>
                        <div class="part" id="p13">
                            {result.Disinfection2Concentration && <span>{result.Disinfection2Concentration}</span>}
                            {!result.Disinfection2Concentration && <span>*****</span>}
                        </div>
                        <div class="part" id="p14">
                            {result.Disinfection2DateString && <span>{result.Disinfection2DateString}</span>}
                            {!result.Disinfection2DateString && <span>*****</span>}
                        </div>
                        <div class="part" id="p15">
                            {result.Disinfection2Comment && <span>{result.Disinfection2Comment}</span>}
                            {!result.Disinfection2Comment && <span>*****</span>}
                        </div>
                        <div class="part" id="p16-1">{result.EnglishProvinceName}</div>
                        <div class="part" id="p16-2">{result.IssueNo}</div>
                        <div class="part" id="p16-3">{result.ConfirmDateString}</div>
                        <div class="part" id="p16-4">{result.ConfirmerEnglishName} {result.ConfirmerUserCode}</div>
                        <div class="part" id="p16-5"></div>
                    </div>
                </div>
            )}
        </div>
    );

    function generateStars(value, len) {
        len = len || 0;
        if (value != null)
            return new Array(len - value.length < 0 ? 0 : len - value.length).join('*') || '';
        else
            return '';
    }
    function search() {
        setResultState('loading');
        let exists = false;
        axios.post('EPhytosanitary/Get', {
            SerialNo: code,
            IssuanceProvinceID: parseInt(place),
            ConfirmDate: date
        }).then((response) => {
            if (response && response.data && response.data.Data) {
                exists = true;
                setResult(response.data.Data);
                setResultState('found');
                return axios.post('Document/GetAttachments', { ObjectID: response.data.Data.ID });
            }
        }).then((response) => {
            if (response && response.data && response.data.Data && response.data.Data.length) {
                response.data.Data.map((item) => {
                    let filePath = window.location.origin;
                    if (filePath === undefined) {
                        filePath = window.location.protocol + '//'
                            + window.location.hostname
                            + (window.location.port ? ':' + window.location.port : '');
                    }
                    filePath += `/TemporaryFiles/${item.FileNameWithExtension}`;
                    item.filePath = filePath;
                });

                setAttachments(response.data.Data.filter((attachment) => {
                    return [4, 5].indexOf(attachment.Type) !== -1;
                }));
            }

            //if (exists)
            //    setResultState('found');
            //else
            //    setResultState('notFound');
        });
    }
    function print() {
        var canvas = document.getElementById("qrcode-canvas");
        var img = canvas.toDataURL("image/png");
        document.getElementById('qrcode-image').src = img;

        const toPrint = document.getElementById('print');
        const popupWin = window.open(
            "",
            "_blank",
            "width=800,height=600,location=no,left=100px"
        );
        popupWin.document.open();
        popupWin.document.write(
            "<html><title></title><style>body,html{margin:0;padding:0}#print-container{height:29.7cm;width:21cm;font-family:tahoma;font-size:10px}.part{position:absolute;color: #686868;font-weight: 600;}.part>span{display:block;margin-bottom : 7px;}#p0{top:2.5cm;left:12.5cm;width:8.5cm;text-indent:2cm}#p1{top:5.0cm;left:1.8cm;width:8.5cm;text-indent:2cm}#p2{top:5.0cm;left:11.3cm;width:8.3cm;text-indent:2.8cm}#p3{top:8cm;left:1.5cm;width:8.5cm;text-indent:2.7cm}#p4{top:8cm;left:11.3cm;width:8.3cm;text-indent:2.1cm}#p5{top:9.35cm;left:1.5cm;width:8.5cm;text-indent:2.1cm}#p6{top:9.35cm;left:11.3cm;width:8.3cm;text-indent:1.9cm}#p7-0{top:11.55cm;left:1cm;width:0.5cm}#p7-1{top:11.55cm;left:1.5cm;width:3cm}#p7-2{top:11.55cm;left:5.8cm;width:3.3cm}#p7-3{top:11.55cm;left:11cm;width:3.2cm}#p7-4{top:11.55cm;left:15cm;width:2.5cm}#p7-5{top:11.55cm;left:17.8cm;width:2.4cm}#p9{top:18.7cm;left:1.5cm;width:18cm;text-indent:1.7cm}#p10{top:21.9cm;left:1.5cm;width:9.3cm;text-indent:1.5cm}#p11{top:22.9cm;left:1.5cm;width:4.8cm;text-indent:2.5cm}#p12{top:22.9cm;left:8cm;width:3.7cm;text-indent:1cm}#p13{top:24.55cm;left:1.5cm;width:4.8cm;text-indent:.8cm}#p14{top:24.58cm;left:8cm;width:3.7cm;text-indent:.5cm}#p15{top:25.8cm;left:2cm;width:9cm;text-indent:1.6cm}#p16-1{top:20.9cm;left:14cm;width:6.5cm}#p16-2{top:21.9cm;left:14cm;width:6.5cm}#p16-3{top:22.9cm;left:14cm;width:6.5cm}#p16-4{top:24.5cm;left:13cm;width:7.5cm}#p16-5{top:26.5cm;left:13cm;width:6.5cm}</style></head><body>"
        );
        popupWin.document.write(toPrint.innerHTML);
        popupWin.document.write("</html>");
        popupWin.document.close();
    }
}

export default Validate;